import {
	promoIconSX,
	separatorSx,
	typoSX,
} from '@/components/blocks/PromotionCard/styles/PromoIconStyles';
import {
	PRODUCT_CARD_PROMO_ICONS_IMG_URL,
	PROMOTION_TYPES,
} from '@/data/constants/promoIconConstants';
import { useLocalization } from '@/data/Localization';
import { useSettings } from '@/data/Settings';
import { setClassName } from '@/data/utils/usePromoIcons/promoLists';
import { Box, CardMedia, Divider, Stack, Typography, useMediaQuery, useTheme } from '@mui/material';

export const Combo = () => {
	const { settings } = useSettings();
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down('md'));
	const { TakeMore, ComboPrices } = useLocalization('PromoIconsTxt');
	const imageServerHostName = settings?.userData?.IMAGE_SERVER_HOSTNAME ?? '';
	return (
		<>
			<Divider sx={separatorSx} />
			<Stack direction="row" sx={{ alignItems: 'center' }} id={PROMOTION_TYPES.PROMORIBBON_COMBO}>
				<CardMedia
					image={imageServerHostName + PRODUCT_CARD_PROMO_ICONS_IMG_URL.PROMORIBBON_COMBO}
					sx={promoIconSX.combo}
					title={TakeMore.t()}
					component="img"
					className={setClassName(PROMOTION_TYPES.PROMORIBBON_COMBO)}
				/>
				<Box>
					<Typography variant="body1" component={isMobile ? 'p' : 'span'} sx={typoSX.firstRow}>
						{TakeMore.t()}{' '}
					</Typography>
					<Typography variant="body1" sx={typoSX.secondRow} component={'span'}>
						{ComboPrices.t()}
					</Typography>
				</Box>
			</Stack>
		</>
	);
};
